'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _panelsUi = require('panels-ui');

var _browserVendorPrefix = require('browser-vendor-prefix');

var _style = require('../style');

var _reactRedux = require('react-redux');

var _finalsActions = require('../finals/actions');

var _groupGetGroupId = require('../group/get-group-id');

var _groupGetGroupId2 = _interopRequireDefault(_groupGetGroupId);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _widgetsSponsor = require('../widgets/sponsor');

var _widgetsSponsor2 = _interopRequireDefault(_widgetsSponsor);

var Dot = function Dot(props) {
  return _react2['default'].createElement('div', { style: _extends({}, props.style, style.dot) });
};

var GoalTeam1 = function GoalTeam1(props) {
  return _react2['default'].createElement(
    'div',
    { style: style.goalTeam1 },
    _react2['default'].createElement(
      'div',
      { style: style.goalPlayerTeam1 },
      props.playersById[props.playerId].name
    ),
    _react2['default'].createElement(Dot, { style: { marginLeft: 10 } })
  );
};

var GoalTeam2 = function GoalTeam2(props) {
  return _react2['default'].createElement(
    'div',
    { style: style.goalTeam2 },
    _react2['default'].createElement(Dot, { style: { marginRight: 10 } }),
    _react2['default'].createElement(
      'div',
      { style: style.goalPlayerTeam2 },
      props.playersById[props.playerId].name
    )
  );
};

var Chukker = function Chukker(props) {
  return _react2['default'].createElement(
    'div',
    { style: style.chukker },
    _react2['default'].createElement(
      'div',
      { style: style.chukkerHeading },
      props.number + 'º Chukker (' + props.score.team1 + ' - ' + props.score.team2 + ')'
    ),
    props.goals.map(function (goal, i) {
      return goal.team === 'team1' ? _react2['default'].createElement(GoalTeam1, _extends({}, goal, { playersById: props.playersById, key: i })) : _react2['default'].createElement(GoalTeam2, _extends({}, goal, { playersById: props.playersById, key: i }));
    })
  );
};

var Match = function Match(props) {
  var wrapperStyle = {
    marginTop: 25
  };
  var team2MatchContent = _extends({}, style.matchContent, {
    marginLeft: 10
  });

  var team1Name = props.teamsById[props.team1.id] ? props.teamsById[props.team1.id].name : props.team1.id;
  var team2Name = props.teamsById[props.team2.id] ? props.teamsById[props.team2.id].name : props.team2.id;

  var chukkers = undefined;

  if (props.final.active) {
    chukkers = props.final.chukkers.map(function (chukker, i) {
      return chukker.active && _react2['default'].createElement(Chukker, _extends({ key: i }, chukker, { playersById: props.playersById }));
    });
  }

  return _react2['default'].createElement(
    'div',
    { style: wrapperStyle },
    _react2['default'].createElement(
      'div',
      { style: style.matchHeading },
      props.heading
    ),
    props.final.active && _react2['default'].createElement(
      'div',
      { style: style.matchContentWrapper },
      _react2['default'].createElement(
        'div',
        { style: style.matchContent },
        _react2['default'].createElement(
          'div',
          { style: style.matchTeam },
          _react2['default'].createElement('img', { src: '/teams/' + props.team1.id + '/logo.svg', alt: props.team1.id, style: style.teamLogo })
        ),
        _react2['default'].createElement('div', { style: style.matchScore })
      ),
      _react2['default'].createElement(
        'div',
        { style: team2MatchContent },
        _react2['default'].createElement('div', { style: style.matchScore }),
        _react2['default'].createElement(
          'div',
          { style: style.matchTeam },
          _react2['default'].createElement('img', { src: '/teams/' + props.team2.id + '/logo.svg', alt: props.team2.id, style: style.teamLogo })
        )
      )
    ),
    _react2['default'].createElement(
      'div',
      { style: style.matchContentWrapper },
      _react2['default'].createElement(
        'div',
        { style: style.matchContent },
        _react2['default'].createElement(
          'div',
          { style: style.matchTeam },
          team1Name
        ),
        _react2['default'].createElement(
          'div',
          { style: style.matchScore },
          props.final.score ? props.final.score.team1 : 0
        )
      ),
      _react2['default'].createElement(
        'div',
        { style: team2MatchContent },
        _react2['default'].createElement(
          'div',
          { style: style.matchScore },
          props.final.score ? props.final.score.team2 : 0
        ),
        _react2['default'].createElement(
          'div',
          { style: style.matchTeam },
          team2Name
        )
      )
    ),
    chukkers
  );
};

exports.Match = Match;

var Final = (function (_Component) {
  _inherits(Final, _Component);

  function Final() {
    _classCallCheck(this, Final);

    _Component.apply(this, arguments);
  }

  Final.prototype.componentDidMount = function componentDidMount() {
    var _this = this;

    this.props.dispatch(_finalsActions.getFinal(this.props.tournamentId));

    this.interval = setInterval(function () {
      return _this.props.dispatch(_finalsActions.getFinal(_this.props.tournamentId));
    }, 10 * 1000);
  };

  Final.prototype.componentWillUnmount = function componentWillUnmount() {
    clearInterval(this.interval);
  };

  Final.prototype.render = function render() {
    return _react2['default'].createElement(
      _panelsUi.Panel,
      { width: this.props.width, style: style.panel },
      _react2['default'].createElement(
        'h1',
        { style: style.title },
        _react2['default'].createElement(
          'span',
          null,
          this.props.club.name
        ),
        _react2['default'].createElement(
          'span',
          null,
          'la final'
        )
      ),
      _react2['default'].createElement(_widgetsSponsor2['default'], _extends({}, this.props.sponsor, { colour: 'BLUE', style: style.sponsor })),
      _react2['default'].createElement(
        'h2',
        { style: style.live },
        !this.props.final.done && 'Seguimiento en vivo'
      ),
      _react2['default'].createElement(Match, _extends({}, this.props.match, { teamsById: this.props.teamsById, final: this.props.final, playersById: this.props.playersById }))
    );
  };

  return Final;
})(_react.Component);

exports.Final = Final;

var style = {
  chukker: _extends({}, _browserVendorPrefix.alignItemsCenter, {
    marginTop: 25
  }),
  chukkerHeading: {
    textTransform: 'uppercase'
  },
  dot: {
    backgroundColor: _style.DARK_GREY,
    borderRadius: 20,
    height: 20,
    width: 20
  },
  goalTeam1: _extends({}, _browserVendorPrefix.alignItemsCenter, _browserVendorPrefix.flexDirectionRow, _browserVendorPrefix.alignSelfFlexStart, {
    marginTop: 10,
    width: 'calc(50% + 10px)'
  }),
  goalTeam2: _extends({}, _browserVendorPrefix.alignItemsCenter, _browserVendorPrefix.flexDirectionRow, {
    alignSelf: 'flex-end',
    marginTop: 10,
    width: 'calc(50% + 10px)'
  }),
  goalPlayerTeam1: _extends({}, _browserVendorPrefix.flex1, {
    textAlign: 'right'
  }),
  goalPlayerTeam2: _extends({}, _browserVendorPrefix.flex1),
  matchHeading: {
    fontSize: 14
  },
  matchContent: _extends({}, _browserVendorPrefix.alignItemsCenter, _browserVendorPrefix.flex1, _browserVendorPrefix.flexDirectionRow, _browserVendorPrefix.justifyContentSpaceBetween),
  matchContentWrapper: _extends({}, _browserVendorPrefix.flexDirectionRow, {
    marginTop: 5
  }),
  matchTeam: {
    textTransform: 'uppercase'
  },
  matchScore: {
    fontSize: 25
  },
  live: {
    fontSize: 20,
    fontWeight: _style.FONT_LIGHT,
    marginTop: 85
  },
  panel: {
    backgroundColor: _style.WHITE_TRANSPARENT_85,
    color: _style.BLUE,
    fontFamily: _style.FONT,
    fontWeight: _style.FONT_LIGHT,
    paddingBottom: 200,
    paddingLeft: 35,
    paddingRight: 35
  },
  teamLogo: {
    height: 75
  },
  title: {
    fontSize: 20,
    fontWeight: _style.FONT_LIGHT,
    marginTop: 85,
    textTransform: 'uppercase'
  },
  sponsor: {
    marginTop: 25
  }
};

function mapStateToProps(state, props) {
  var tournament = state.tournaments.byId[props.tournamentId];
  var matches = state.fixtures.byTournamentId[props.tournamentId];
  var match = state.fixtures.byId[matches[matches.length - 1]];
  var final = state.finals.byTournamentId[props.tournamentId];

  return {
    club: state.tournaments.clubsById[props.tournamentId],
    final: final,
    match: match,
    sponsor: state.tournaments.sponsorsById[tournament.sponsorId],
    playersById: state.teams.playersById,
    teamsById: state.teams.byId
  };
}

exports['default'] = _reactRedux.connect(mapStateToProps)(Final);